export var TypeActionFortuneTellerEventInfo;
(function (TypeActionFortuneTellerEventInfo) {
    TypeActionFortuneTellerEventInfo["Collect"] = "FortuneTellerEvent > Collect";
    TypeActionFortuneTellerEventInfo["Request"] = "FortuneTellerEvent > Request";
    TypeActionFortuneTellerEventInfo["Received"] = "FortuneTellerEvent > Received";
    TypeActionFortuneTellerEventInfo["BuyPackage"] = "FortuneTellerEvent > BuyPackage";
    TypeActionFortuneTellerEventInfo["RequestBuyPackage"] = "FortuneTellerEvent > RequestBuyPackage";
    TypeActionFortuneTellerEventInfo["FinishBuyPackageCoolDown"] = "FortuneTellerEvent > FinishBuyPackageCoolDown";
})(TypeActionFortuneTellerEventInfo || (TypeActionFortuneTellerEventInfo = {}));
export var actionFortuneTellerEventReceived = function (fortune) { return ({
    fortune: fortune,
    type: TypeActionFortuneTellerEventInfo.Received,
}); };
export var actionFortuneTellerEventBuyPackage = function (packageId) { return ({
    packageId: packageId,
    type: TypeActionFortuneTellerEventInfo.BuyPackage,
}); };
export var actionFortuneTellerEventRequestBuyPackage = function (packageId) { return ({
    packageId: packageId,
    type: TypeActionFortuneTellerEventInfo.RequestBuyPackage,
}); };
export var actionFortuneTellerEventRequest = function () { return ({
    type: TypeActionFortuneTellerEventInfo.Request,
}); };
export var actionFortuneTellerEventCollect = function () { return ({
    type: TypeActionFortuneTellerEventInfo.Collect,
}); };
export var actionFortuneTellerEventFinishBuyPackageCoolDown = function () { return ({
    type: TypeActionFortuneTellerEventInfo.FinishBuyPackageCoolDown,
}); };



//////////////////
// WEBPACK FOOTER
// ./src/features/fortune-teller-event/actionFortuneTellerEventInfo.ts
// module id = 217
// module chunks = 3